import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {

    isParaActive = false;
    isBtnActive = false;
  constructor() { }

  ngOnInit() {
  }


  toggleClass() {
    this.isParaActive = !this.isParaActive;
    this.isBtnActive = !this.isBtnActive;
  }

}



// WEBPACK FOOTER //
// ./src/app/common/filters/filters.component.ts